<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component components/buyers-select/buyers-select.component.ts
-->
<ng-template #anchor></ng-template>
